import { render, staticRenderFns } from "./FooterPlus.vue?vue&type=template&id=8b83655e&scoped=true"
import script from "./FooterPlus.vue?vue&type=script&lang=js"
export * from "./FooterPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b83655e",
  null
  
)

export default component.exports